<ng-template [ngIf]="isOpen" role="alert" [ngClass]="classes">
    <ng-template [ngIf]="dismiss">
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
        <span class="visually-hidden">Close</span>
      </button>
    </ng-template>
    <ng-content></ng-content>
</ng-template>
